(function() {
    angular.module('templates', []);
    var app = angular.module('sepedi_sentence_helper', ['templates','angular-preload-image', 'ngAnimate', 'ui.bootstrap']);

    angular.element(document).ready(function($rootScope) {
        angular.bootstrap(document, ['sepedi_sentence_helper']);
    });

    app.run(function($rootScope, $location) {

        $rootScope.baseURL = $location.absUrl();//'http://localhost:8080/sepedi_helper/combined';

        $rootScope.setBaseURL = function (newURL) {
            $rootScope.baseURL = newURL;
        };
        var freezeframe_options = {
            class_name: "help_image",
            loading_background_color: "gray",
            animation_icon_position: "center center",
            trigger_event: "click",
            animation_icon_image: $location.absUrl() + "/img/help_play_icon.png",
            animation_play_duration: 30000
        };
        $rootScope.freezeframe_options = freezeframe_options;
    });

    app.constant('API_PART_URL', 'api');
})();
(function() {
	angular.module('sepedi_sentence_helper')
    .directive('verbInputContainter', function () {
    return {
        restrict: 'E',
        controller:'verbInputController',
        controllerAs:'vm',
        scope:{
            editMode:'=',
            pushChange:'='
        },
        replace: true,
        templateUrl: 'app/views/templates/input/verbInputContainer.html',
        link: function ($scope, $element, $attributes, $controller) {
            
            $scope.editMode.invoke = $controller.editMode;
            $controller.pushChange = $scope.pushChange;
        }
    };
  });
})();
(function() {
	var app = angular.module('sepedi_sentence_helper');
	app.directive('typeAheadSelect', ['generalService', function(generalService) {
    return {
        restrict: 'E',
        scope:{
            options:'=',
            data:'=',
            getList:'&'
        },
        replace: true,
        templateUrl: 'app/views/templates/input/typeAheadSelect.html',
        link: function ($scope, $attr, $element) {
            
        
            $scope.sanitize = function (value) {
                value = value.toLowerCase(value);
                value = value.replace("the ","");
                value = value.replace("a ","");
                value = value.replace("an ","");
                return value;
            }

            $scope.getWords = function (value) {
                $scope.loadingWords = true;
                return $scope.getList({value:value}).then(function (data) {
                    var temp_response = [];
                    for (var key in data) {
                        var temp_value = data[key];
                        temp_response.push({order:temp_value.order,value:temp_value.id,label:temp_value.label,word:temp_value.word});
                    }
                    $scope.data_set = temp_response;
                    $scope.loadingWords = false;
                    return temp_response;       
                });
            };
            
            $scope.element_changed = function(selected) {
                $scope.show_as_error = false;
                $scope.show_as_correct = true;
                $scope.data.value = selected;
            };
            
            $scope.clear = function () {
                $scope.data_set = [];
                $scope.data_set.push({value:'',label:'',word:''});
                $scope.selected = {value:'',label:'',word:''};
                $scope.typed_value = '';
                $scope.show_as_error = true;
                $scope.show_as_correct = false;
                
                $scope.data.value = {value:'',label:'',word:''};
            }
            
            $scope.restore = function(selected) 
            {
                $scope.selected = $scope.data.value;
            };
            
            $scope.track_typing = function(current_typed_value) {
                $scope.typed_value = current_typed_value;
            };
            
            $scope.update = function() {
                $scope.show_as_error = false;
                $scope.show_as_correct = true;
            };
            
            $scope.openHelp = function () {
                generalService.openHelp($scope.data.type_id);
            };
        }
    };
  }]);
})();
(function() {
    angular.module('sepedi_sentence_helper')
    .directive('typeAheadInput', function () {
        return {
            restrict: 'E',
            controller: 'typeAheadInputController',
            constrollerAs: 'vm',
            scope: {
                type:'@',
                init:'=',
                pushChange: '=',
                getWords:'='
            },
            replace: true,
            templateUrl: 'app/views/templates/input/typeAheadInput.html',
            link: function ($scope, $element, $attributes, $controller) {
                $scope.vm = $controller;

                $scope.init.invoke = $controller.init;
                $controller.input_type = $scope.type;
                $controller.pushChange = $scope.pushChange;
                $controller.getWordsFromParent = $scope.getWords;
            }
        };
    });
})();

(function() {
	var app = angular.module('sepedi_sentence_helper');
	app.directive('sentenceTypeChooser', function() {
    return {
        restrict: 'E',
        scope:false,
        replace: true,
        templateUrl: 'app/views/templates/input/sentenceTypeChooser.html'
    };
  });
})();
(function() {
	var app = angular.module('sepedi_sentence_helper');
	app.directive('sentenceInterfaceOptions', function() {
    return {
        restrict: 'E',
        scope:false,
        replace: true,
        templateUrl: 'app/views/templates/input/sentenceInterfaceOptions.html'
    };
  });
})();
(function() {
	var app = angular.module('sepedi_sentence_helper');
	app.directive('sentenceInterface', function() {
        return {
            restrict: 'E',
            scope:false,
            replace: true,
            templateUrl: 'app/views/templates/input/sentenceInterface.html'
        };
    });
})();
(function() {
	var app = angular.module('sepedi_sentence_helper');
	app.directive('sentenceInputStep', function() {
    return {
        restrict: 'E',
        scope:false,
        replace: true,
        templateUrl: 'app/views/templates/input/sentenceInputStep.html'
    };
  });
})();
(function() {
	angular.module('sepedi_sentence_helper')
    .directive('radioButtonGroupInput', function () {
    return {
        restrict: 'E',
        controller:'radioButtonGroupInputController',
        constrollerAs: 'vm',
        scope: {
            init:'=',
            pushChange: '='
        },
        replace: true,
        templateUrl: 'app/views/templates/input/radioButtonGroupInput.html',
        link: function ($scope, $element, $attributes, $controller) {
            $scope.vm = $controller;

            $scope.init.invoke = $controller.init;
            $controller.pushChange = $scope.pushChange;
        }
    };
  });
})();
(function() {
	angular.module('sepedi_sentence_helper')
    .directive('nounInputContainter', function () {
    return {
        restrict: 'E',
        controller:'nounInputController',
        controllerAs:'vm',
        scope:{
            editMode:'=',
            pushChange:'='
        },
        replace: true,
        templateUrl: 'app/views/templates/input/nounInputContainer.html',
        link: function ($scope, $element, $attributes, $controller) {
            
            $scope.editMode.invoke = $controller.editMode;
            $controller.pushChange = $scope.pushChange;
        }
    };
  });
})();
(function() {
	var app = angular.module('sepedi_sentence_helper');
	app.directive('nounInput', function() {
    return {
        restrict: 'E',
        scope:false,
        replace: true,
        templateUrl: 'app/views/templates/input/nounInput.html'
    };
  });
})();
(function() {
	var app = angular.module('sepedi_sentence_helper');
	app.directive('labelWord', function() {
    return {
        restrict: 'E',
        scope:false,
        replace: true,
        templateUrl: 'app/views/templates/input/labelWord.html'
    };
  });
})();
(function() {
	var app = angular.module('sepedi_sentence_helper');
	app.directive('inputSetContainer', function() {
    return {
        restrict: 'E',
        scope:false,
        replace: false,
        transclude: true,
        templateUrl: 'app/views/templates/input/inputSetContainer.html',
        link: function ($scope, $element, $attrs, $ctrl, $transclude) {
            $transclude($scope, function(clone) {
                var transcludePlaceholder = $element[0].querySelector('#transclude-placeholder');
                transcludePlaceholder = angular.element(transcludePlaceholder);
                transcludePlaceholder.replaceWith(clone);
            });
        }
    };
  });
})();
(function() {
	var app = angular.module('sepedi_sentence_helper');
	app.directive('fullRowDisplaySetContainer', function() {
    return {
        restrict: 'E',
        scope:false,
        replace: false,
        transclude: true,
        templateUrl: 'app/views/templates/input/fullRowDisplaySetContainer.html'
//        ,
//        link: function(scope, element, attrs, ctrl, transclude) {
//            transclude(scope.$parent, function(clone, scope) {
//                element.append(clone);
//            });
//        }
    };
  });
})();
(function() {
	angular.module('sepedi_sentence_helper')
    .directive('componentContainer', function() {
    return {
        restrict: 'E',
        scope:false,
        replace: false,
        transclude: true,
        templateUrl: 'app/views/templates/input/componentContainer.html',
        link: function ($scope, $element, $attrs, $ctrl, $transclude) {
            $transclude($scope, function(clone) {
                var transcludePlaceholder = $element[0].querySelector('#transclude-placeholder');
                transcludePlaceholder = angular.element(transcludePlaceholder);
                transcludePlaceholder.replaceWith(clone);
            });
        }
    };
  });
})();
(function() {
	var app = angular.module('sepedi_sentence_helper');
	app.directive('centreComponentContainer', function() {
    return {
        restrict: 'E',
        scope:false,
        replace: false,
        transclude: true,
        templateUrl: 'app/views/templates/input/centreComponentContainer.html'
    };
  });
})();
(function () {
    var app = angular.module('sepedi_sentence_helper');
    app.directive('autoCompleteBuster', function () {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function ($scope, $element, $attrs, $ngModelController) {
                var autocompleteBustVar = function () {
                    this.setAttribute("autocomplete","" + new Date().getTime())
                    this.setAttribute("aria-autocomplete","" + new Date().getTime())
                };
                $element.on('focus', autocompleteBustVar);
                $element.on('blur', autocompleteBustVar);
            }
        };
    });
})();
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.service('serverCallsService',['$http', '$q', '$rootScope', 'API_PART_URL', function ($http, $q, $rootScope, API_PART_URL) {

        this.getSetup = function(value) {
            return this.getCall($rootScope.baseURL + API_PART_URL + '/GetSetup.php?value=' + value);
        };

        this.getNouns = function(value) {
            return this.getCall($rootScope.baseURL + API_PART_URL + '/GetNoun.php?value=' + value);
        };

        this.getVerbs = function(value) {
            return this.getCall($rootScope.baseURL + API_PART_URL + '/GetVerb.php?value=' + value);
        };

        this.getAdjectives = function(value, nounClass) {
            return this.getCall($rootScope.baseURL + API_PART_URL + '/GetAdjective.php?value=' + value + '&nounclass=' + nounClass);
        };

        this.getPossessives = function(value, nounClass) {
            return this.getCall($rootScope.baseURL + API_PART_URL + '/GetNoun.php?type=possessive&value=' + value);
        };

        this.getCall = function(url) {
            var deferred = $q.defer();
            $http.get(url).success(
                function (response) {
                deferred.resolve(response);
            }).error(
                function (response, status) {
                deferred.reject({response: response, status: status});
            });
            return deferred.promise;
        };

        this.getSentence = function(data) {
            return this.postCall($rootScope.baseURL + API_PART_URL + '/GetSentence.php', data);
        };

        this.postCall = function(url, data) {
            var deferred = $q.defer();
            var postData = 'data='+JSON.stringify(data);
            $http({
				method: 'POST',
				url: url,
				data: postData,
				headers: {'Content-Type': 'application/x-www-form-urlencoded'}
			}).success(function(response, status) {
                deferred.resolve(response);
            }).error(function(response, status)
            {
                deferred.reject({response: response, status: status});
            });
            return deferred.promise;
        };

    }])
})();

(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.service('sentenceService',['$q', 'generalService', 'serverCallsService', function ($q, generalService, serverCallsService) {
        
        var dictionaryEntryController;
        var sentenceInterfaceController;
        var sentenceInterfaceOptionsController;
        var sentenceInputStepDisplayController = [];
        var sentenceTypeController;
        var inputs = [];
        
        this.bindDictionaryEntryController = function ($scope) {
            dictionaryEntryController = $scope;
        };

        this.bindSentenceInterfaceController = function ($scope) {
            sentenceInterfaceController = $scope;
        };
        
        this.bindSentenceInterfaceOptionsController = function ($scope) {
            sentenceInterfaceOptionsController = $scope;
        };
        
        this.bindController = function ($scope) {
            inputs[$scope.type] = $scope;
        };
        
        this.bindSentenceTypeController = function ($scope) {
            sentenceTypeController = $scope;
        };        
        
        this.bindSentenceInputStepDisplayController = function ($scope,index) {
            sentenceInputStepDisplayController[index] = $scope;
        };
        
        this.getSentenceTypes = function () {
            return dictionaryEntryController.getSentenceTypes();
        };
        
        this.setSentenceType = function (type) {
            dictionaryEntryController.setupSentenceType(type);
        };
        
        this.pushWords = function() {
            sentenceInterfaceController.getWords();
        };

        this.getWords = function() {
            return dictionaryEntryController.getWords();
        };
        
        this.getInputs = function() {
            return dictionaryEntryController.getInputs();
        };

        this.setSentenceWords = function() {
            sentenceInterfaceController.getWords();
        };
        
        this.setCheckedWord = function() {
            sentenceInterfaceController.setChecked();
        };
            
        this.editMode = function(word) {
            dictionaryEntryController.editMode(word);
        };
        
        this.editModeViaName = function(machine_name) {
            dictionaryEntryController.editModeViaName(machine_name);
        };
        
        this.updateDisplay = function () {
            for (var i=0; i<sentenceInputStepDisplayController.length; i++)
                sentenceInputStepDisplayController[i].updateDisplay();
        };
        
        this.sentenceSetAdditionalWord = function(input) {
            sentenceInterfaceOptionsController.sentenceSetAdditionalWord(input);
        };
        
        this.pushSentenceOptions = function (Inputs) {
            sentenceInterfaceOptionsController.sentenceSetOptions(Inputs);
        };
        
        this.pushEditToController = function(input, type) {
            inputs[type].editMode(input);
        };
        
        this.pushControllerChange = function(machine_name) {
            dictionaryEntryController.changeFromController(machine_name);
        };  
        
        this.undo = function(undoAll) {
            dictionaryEntryController.undo(undoAll);
        };   
        
        this.updateChechedWord = function(word) {
            sentenceInterfaceController.setChecked(word);
        };
            
        this.getCheckedWord = function () {
            return sentenceInterfaceController.getCheckedWord();    
        }; 
    }]);
})();
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.service('nounService',['$q', 'generalService', 'serverCallsService', function ($q, generalService, serverCallsService) {
        
        var nounController;
        var typeAhead;
            
        this.getNoun = function(value) {
            return serverCallsService.getNoun(value);
        };
        
        this.openHelp = function(options) {
            generalService.openHelp(options);
        };
        
        this.bindTypeAhead = function ($typeAheadScope) {
            typeAhead = $typeAheadScope
        };
        
        this.bindNounController = function ($nounControllerScope) {
            nounController = $nounControllerScope;
        };
        
        this.selectedWord = function(word) {
            nounController.selectedWord(word);
        };
        
        this.initTypeAheadRequest = function() {
            nounController.initTypeAhead();
        };
        
        this.initializeTypeAhead = function(data_id, data_label, data_value) {
            typeAhead.initialize(data_id, data_label, data_value);
        };
    }]);
})();
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.service('inputService', ['generalService','serverCallsService', function (generalService, serverCallsService) {
        var inputControllers = [];
        var typeAheads = [];
        var radioSets = [];
        
        this.bindInputController = function ($inputControllerScope) {
            inputControllers[$inputControllerScope.type] = $inputControllerScope;
        };

        this.bindTypeAhead = function ($typeAheadScope) {
            typeAheads[$typeAheadScope.type] = $typeAheadScope;
        };

        this.bindRadioSets = function ($radioScope) {
            radioSets[$radioScope.type] = $radioScope;
        };
        
        this.getWords = function(value, type) {
            return inputControllers[type].getWords(value, type);
        };
        
        this.openHelp = function(options) {
            generalService.openHelp(options);
        };
        
        this.selectedWord = function(id, word, type) {
            inputControllers[type].selectedWord(id, word);
        };

        this.selectedRadio = function(id, option, type) {
            inputControllers[type].selectedRadioOption(id, option);
        };
        
        this.initTypeAheadRequest = function(type) {
            inputControllers[type].initTypeAhead();
        };
        
        this.initTypeAhead = function(type, data_id, data_label, data_value, data_display) {
            typeAheads[type].initialize(data_id, data_label, data_value, data_display);
        };
        
        this.initRadioSetRequest = function(type) {
            inputControllers[type].initRadioSet();
        };
        
        this.initRadioSet = function(type, data_id, data_label, data_value, data_options) {
            radioSets[type].initialize(data_id, data_label, data_value, data_options);
        };
    }]);
})();
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.service('imageLoadService',['$http', '$q', '$rootScope', function ($http, $q, $rootScope) {

        this.getImage = function(value) {
            return this.getCall($rootScope.baseURL + 'gifs/' + value);
        };
        
        this.getCall = function(url) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: url,
                cache: true
            }).then(function(response) {
                deferred.resolve(response);
            });
            return deferred.promise;
        };
        
        this.onInitialLoad = function() {
             this.getImage('full_example.gif').then(
                 this.getImage('posneg.gif').then(
                     this.getImage('subject_noun.gif').then(
                         this.getImage('tense.gif').then(
                             this.getImage('thank_you.gif').then(
                                 this.getImage('verb.gif')
                             )
                         )
                     )
                 )
             );
            //  this.getImage('posneg.gif');
            //  this.getImage('subject_noun.gif');
            //  this.getImage('tense.gif');
            //  this.getImage('thank_you.gif');
            //  this.getImage('verb.gif');
        };
    }])
})();
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.service('generalService',['$rootScope', '$q', function ($rootScope, $q) {
        this.openHelp = function(options) {
            $rootScope.$broadcast('help_for_component',options);
        };
        
        this.openWarning = function(options) {
            $rootScope.$broadcast('notification_warning',options);
        };
    }]);
})();
angular.module('angular-preload-image', []);
angular.module('angular-preload-image').factory('preLoader', function () {
    return function (url, successCallback, errorCallback) {
        //Thank you Adriaan for this little snippet: http://www.bennadel.com/members/11887-adriaan.htm
        angular.element(new Image()).bind('load', function () {
            successCallback();
        }).bind('error', function () {
            errorCallback();
        }).attr('src', url);
    }
});
angular.module('angular-preload-image').directive('preloadImage', ['$rootScope', '$timeout', 'preLoader', function ($rootScope, $timeout, preLoader) {
    return {
        restrict: 'A',
        terminal: true,
        priority: 100,
        link: function (scope, element, attrs) {
            scope.default = attrs.defaultImage || "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wEWEygNWiLqlwAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAAMSURBVAjXY/j//z8ABf4C/tzMWecAAAAASUVORK5CYII=";
            attrs.$observe('ngSrc', function () {
                var url = attrs.ngSrc;
                attrs.$set('src', scope.default);
                attrs.$set('animation-gifs-wrapper','');
                preLoader(url, function () {
                    attrs.$set('src', url);
                    $timeout(function () {
                        freezeframe = new FreezeFrame($rootScope.freezeframe_options);
                        freezeframe.setup();
                        freezeframe.run();
                    });
                }, function () {
                    if (attrs.fallbackImage != undefined) {
                        attrs.$set('src', attrs.fallbackImage);
                    }
                });
            })

        }
    };
}]);
angular.module('angular-preload-image').directive('preloadBgImage', ['preLoader', function (preLoader) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            if (attrs.preloadBgImage != undefined) {
                //Define default image
                scope.default = attrs.defaultImage || "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wEWEygNWiLqlwAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAAMSURBVAjXY/j//z8ABf4C/tzMWecAAAAASUVORK5CYII=";

                attrs.$observe('preloadBgImage', function () {
                    element.css({
                        'background-image': 'url("' + scope.default + '")'
                    });
                    preLoader(attrs.preloadBgImage, function () {
                        element.css({
                            'background-image': 'url("' + attrs.preloadBgImage + '")'
                        });
                    }, function () {
                        if (attrs.fallbackImage != undefined) {
                            element.css({
                                'background-image': 'url("' + attrs.fallbackImage + '")'
                            });
                        }
                    });
                });
            }
        }
    };
}]);
(function() {
  var app = angular.module('sepedi_sentence_helper');
  app.filter("toArrayFilter", function($compile, $timeout) {
    return function (obj, addKey) {
      if (!angular.isObject(obj)) return obj;
      if ( addKey === false ) {
        return Object.keys(obj).map(function(key) {
          return obj[key];
        });
      } else {
        return Object.keys(obj).map(function (key) {
          var value = obj[key];
          return angular.isObject(value) ?
            Object.defineProperty(value, '$key', { enumerable: false, value: key}) :
            { $key: key, $value: value };
        });
      }
    };
  });
})();
(function() {
	var app = angular.module('sepedi_sentence_helper');
	app.filter('objectToArray', function() {
    return function(input) {
      var out = []; 
      for(i in input){
        out.push(input[i]);
      }
      return out;
    };
  });
})();
(function() {
	var app = angular.module('sepedi_sentence_helper');
  app.directive("bindCompiledHtml", function($compile, $timeout) {
    return {
      template: '<div></div>',
      scope: {
        rawHtml: '=bindCompiledHtml'
      },
      link: function(scope, elem, attrs) {
        scope.$watch('rawHtml', function(value) {
          if (!value) return;
          // we want to use the scope OUTSIDE of this directive
          // (which itself is an isolate scope).
          var newElem = $compile(value)(scope.$parent);
          elem.contents().remove();
          elem.append(newElem);
        });
      }
    };
  });
})();
(function() {
  var app = angular.module('sepedi_sentence_helper');
  app.directive("animationGifsWrapper", ['$timeout','$rootScope', function($timeout,$rootScope) {
    return {
      link: function($scope, $elem, $attrs) {
        $timeout(function () {
          freezeframe = new FreezeFrame($rootScope.freezeframe_options);
          freezeframe.setup();
          freezeframe.run();
        });
      }
    };
  }]);
})();
(function() {
    angular.module('sepedi_sentence_helper')
    .controller('verbInputController', 
    function ($scope, serverCallsService) {
        var vm = this;
        vm.type = 'verb';
        vm.verb = {};
        
        vm.editMode = $scope.editMode;
        vm.pushChange = $scope.pushChange;     

        vm.childHandles = {};
        vm.childHandles.initVerb = {};
        
        vm.editMode = function(input) {
            vm.Input = input;
            
            vm.verb.id = input.machine_name;
            vm.verb.label = input.label;
            vm.verb.value = input.value;
            vm.verb.displayValue = input.display_value;
            vm.childHandles.initVerb.invoke(vm.verb);
        };

        vm.pushChangeToParent = function() {
            vm.pushChange(vm.verb.label);
        };
        
        vm.selectedVerb = function (data) {
            vm.verb = data;
            vm.Input.previous_value = angular.copy(vm.Input.value);
            vm.Input.value = parseInt(vm.verb.value);
            vm.Input.display_value = vm.verb.displayValue;
            vm.pushChangeToParent();
        }
        
        vm.getVerbs = function (value) {
            return serverCallsService.getVerbs(value);
        };
    });
})();
(function() {
    angular.module('sepedi_sentence_helper')
    .controller('typeAheadInputController',function ($scope, inputService) {
        var vm = this;
        
        vm.init = function(data) {
            vm.data_id = data.id;
            vm.data_label = data.label;
            
            vm.typed_value = '';
            vm.data_vector = {};
            
            vm.data_set = [];
            vm.data_set.push(data.value);
            vm.selected = data.displayValue;
            if (vm.selected) 
                vm.show_clear = true;
            vm.data_value = vm.selected;
            
            vm.show_as_error = true;
            vm.show_as_correct = false;            
        };
        
        vm.sanitize = function (value) {
            value = value.toLowerCase(value);
            value = value.replace("the ","");
            value = value.replace("a ","");
            value = value.replace("an ","");
            return value;
        }

        vm.wordSelected = function() {
            var data = {};
            data.id = vm.data_id;
            data.label = vm.data_label;
            data.value = vm.data_value.value;
            data.word = vm.data_value.word;
            vm.pushChange(data);
        };
                
        vm.getWords = function (value) {
            vm.loadingWords = true;
            return vm.getWordsFromParent(value).then(function (data) {
                var temp_response = [];
                for (var key in data) {
                    var temp_value = data[key];
                    temp_response.push({order:temp_value.order,value:temp_value.id,label:temp_value.label,word:temp_value.word});
                }
                vm.data_set = temp_response;
                return temp_response;       
            });
        };
        
        vm.element_changed = function(selected) {
            vm.data_value = selected;
            vm.show_as_error = false;
            vm.show_as_correct = true;
            vm.wordSelected();
        };
        
        vm.clear = function () {
            vm.data_set = [];
            vm.data_set.push({value:'',label:'',word:''});
            vm.selected = {value:'',label:'',word:''};
            vm.typed_value = '';
            vm.data_value = {value:'',label:'',word:''};
            vm.show_as_error = true;
            vm.show_as_correct = false;
            vm.wordSelected();
        }
        
        vm.restore = function() 
        {
            vm.selected = vm.data_value;
        };
        
        vm.track_typing = function(current_typed_value) {
            vm.typed_value = current_typed_value;
        };
        
        vm.update = function() {
            vm.show_as_error = false;
            vm.show_as_correct = true;
        };
        
        vm.openHelp = function () {
            inputService.openHelp(vm.data_id);
        };
    });
})();
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.controller('testThingsController',['$scope', function ($scope) {
        
        $scope.calls = {type:[]};

        $scope.bind = function(type,binding) {
            //$scope.calls.typesh[{type:type}];
            $scope.calls.type[type] = binding;
            //$scope.test.type.[scope.type] = scope;
        };

        $scope.call = function(binding) {
            $scope.calls.type = binding;
            //$scope.test.type.[scope.type] = scope;
        };

        $scope.type = 'noun';

        $scope.set1 = function (input) {
            $scope.one = input;
        };

        $scope.set2 = function (input) {
            $scope.two = input;
        };

        $scope.bind('1',$scope.set1);
        $scope.bind('2',$scope.set2);

        $scope.calls.type['1'](1);
        $scope.calls.type['2'](2);

        console.log( $scope.calls);

    }]);
})();
/// <reference path="../../../typings/underscore/underscore.d.ts"/>
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.controller('sentenceTypeController',['$scope', 'sentenceService', function ($scope, sentenceService) {
        sentenceService.bindSentenceTypeController($scope);
        
        $scope.setSentenceType = function (type) {
            $scope.chosenType = 
                _.find($scope.sentenceTypes, function(inType) {
                    return inType.machine_name === type;
                });
            sentenceService.setSentenceType(type);
        };
        
        $scope.sentenceTypes = sentenceService.getSentenceTypes();
        $scope.setSentenceType('indicative');
    }]);
})();
/// <reference path="../../../typings/underscore/underscore.d.ts"/>
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.controller('sentenceInterfaceOptionsController',['$scope', 'sentenceService', function ($scope, sentenceService) {
        sentenceService.bindSentenceInterfaceOptionsController($scope);
        
        $scope.sentenceSetAdditionalWord = function (inputs) {
            $scope.additionalInputs = inputs;
        };
        
        $scope.editMode = function (input) {
            sentenceService.editMode(input);
        };
        
        $scope.updateDisplayValue= function(optionInput) {
            optionInput.display_value = (_.find(optionInput.options, {'value': optionInput.value})).label;
        };
        
        $scope.sentenceSetOptions = function (optionsInputs) {
            $scope.optionInputs = optionsInputs;
            for (var i=0; i < $scope.optionInputs.length; i++) {
                $scope.updateDisplayValue($scope.optionInputs[i]);  
            };
        }; 
        
        $scope.selectionPush = function(optionInput, chosen) {
            optionInput.previous_value = angular.copy(optionInput.value);
            optionInput.value = chosen;
            $scope.updateDisplayValue(optionInput);
            sentenceService.pushControllerChange(optionInput.machine_name);
        };        
    }]);
})();
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.controller('sentenceInterfaceController',['$timeout', '$rootScope','$scope', 'sentenceService', function ($timeout, $rootScope, $scope, sentenceService) {
        sentenceService.bindSentenceInterfaceController($scope);
        
        $scope.currentSelected = undefined;
        
        $scope.getCheckedWord = function () {
            if ($scope.words) {
                for (var i=0; i<$scope.words.length; i++) {
                    if ($scope.words[i].selected) {
                        return $scope.words[i];
                    };
                };
            };
            return undefined;
        };
        
        $scope.setChecked = function (word) {
            $scope.currentSelected = word || $scope.currentSelected;
            for (var i=0; i<$scope.words.length; i++) {
                if ($scope.currentSelected) {
                    if ($scope.words[i].machine_name === $scope.currentSelected.machine_name) {
                        $scope.words[i].selected = true; 
                    }
                    else    
                        $scope.words[i].selected = false;
                }
                else 
                    $scope.words[i].selected = false;
            };
        };
        
        $scope.showClear = function () {            
            if ($scope.words) {
                if ($scope.words.length) {
                    for (var i=0; i<$scope.words.length; i++) {
                            if (!($scope.words[i].value.includes('[Choose ')) && !$scope.words[i].fixed)
                                return true;
                    };
                    return false;
                }
                else {
                    return false;
                };                
            }
            else {
                return false;    
            };
        };
        
        $scope.getWords = function() {
            var words = sentenceService.getWords();
            //var showClearCount = words.showClearCount;
            var result = [];
            var keys = _.keys(words);
            angular.forEach(keys, function (key) {
                result.push(words[key]);
            });
            $scope.words = result;
            $scope.setChecked($scope.currentSelected);
        };
        
        $scope.editMode = function(word) {
            sentenceService.editMode(word);
        };
        
        $scope.undoLastChange = function () {
            sentenceService.undo();
        };
        
        $scope.clearSentence = function () {
            var undoAll = true;
            $scope.setChecked();
            sentenceService.undo(undoAll);
        };
        
        //$rootScope.fetchingSentence;
    }]);
})();
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.controller('sentenceInputStepDisplayController',['$scope', 'sentenceService', function ($scope, sentenceService) {
        sentenceService.bindSentenceInputStepDisplayController($scope, $scope.key);
        
        $scope.editMode = function (machine_name) {
            sentenceService.editModeViaName(machine_name);    
        };
        
        $scope.updateDisplay = function () {
            $scope.inputs = sentenceService.getInputs();
            $scope.words = sentenceService.getWords(); 
            $scope.setLabel(); 
            $scope.setComputedValue();
        };       
        
        $scope.getStepCount = function(index) {
            var count = 0;
            for (var i=0; i<index; i++) {
                if ($scope.inputs[i] && $scope.inputs[i].type !== 'label')
                    count++;        
            };    
            return count + 1;        
        };
        
        $scope.setLabel = function () {
            if ($scope.value.type === 'label') {
                $scope.label = 'Generated from ';
            }
            else {
                $scope.label = 'Step '+  ($scope.getStepCount($scope.key)) + ':';
            };           
        };
        
        $scope.setComputedValue = function () {
            var display_value = '[Not Chosen]';
            $scope.disabled = true;
            if ($scope.inputs[$scope.key]) {
                if ($scope.inputs[$scope.key].display_value) {
                    display_value = $scope.inputs[$scope.key].display_value;
                    $scope.disabled = false;
                };
                $scope.computedLabel = $scope.inputs[$scope.key].label;
                $scope.computedValue = display_value;  
                $scope.machine_name = $scope.inputs[$scope.key].machine_name; 
            };  
        };
        
    }]);
})();
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.controller('radioInputController',['$scope', 'inputService', function ($scope, inputService) {
        
        $scope.setType = function (type) {
            $scope.type = type;
            inputService.bindRadioSets($scope);
            //inputService.initRadioSetRequest($scope.type);
        };
        
        $scope.setSelected = function(value) {
            for (var i = 0; i < $scope.data_options.length; i++) {
                if ($scope.data_options[i].value === value) {
                    $scope.data_options[i].checked = true;
                    $scope.radioSelected($scope.data_options[i]);
                }
                else {
                    $scope.data_options[i].checked = false;
                };
            };
        };
        
        $scope.initialize = function(data_id, data_label, data_value, data_options) {
            $scope.data_id = data_id;
            $scope.data_label = data_label;
            var options = [];
            for (var key in data_options) {
                options.push({value:data_options[key].value,label:data_options[key].label,checked:false});
            };
            
            $scope.data_options = options;     
            $scope.setSelected(data_value);
        };

        $scope.radioSelected = function(selected) {
            inputService.selectedRadio($scope.data_id,selected,$scope.type);
        };
                
        $scope.openHelp = function () {
            inputService.openHelp($scope.data_id);
        };        
    }]);
})();
(function() {
    angular.module('sepedi_sentence_helper')
    .controller('radioButtonGroupInputController', function ($scope, inputService) {
        var vm = this;

        vm.init = function(data_id, data_label, data_value, data_options) {
            vm.data_id = data_id;
            vm.data_label = data_label;
            var options = [];
            for (var key in data_options) {
                options.push({value:data_options[key].value,label:data_options[key].label,checked:0});
            }
            
            vm.data_options = options;     
            vm.setSelected(data_value);
        };

        vm.selectionChanged = function(value) {
            vm.radioSelected(value);
        };

        vm.setSelected = function(value) {
            var returnIndex = -1;
            for (var i = 0; i < vm.data_options.length; i++) {
                if (vm.data_options[i].value === value) {
                    vm.data_options[i].checked = 1;
                    returnIndex = i;
                }
                else {
                    vm.data_options[i].checked = 0;
                }
            }
            return vm.data_options[returnIndex];
        };
        
        vm.radioSelected = function(selected) {
            vm.pushChange(vm.data_id, selected);
        };
                
        vm.openHelp = function () {
            inputService.openHelp(vm.data_id);
        };        
    });
})();
(function() {
    angular.module('sepedi_sentence_helper')
    .controller('nounInputController',
    function ($scope, serverCallsService) {
        var vm = this;
        vm.type = 'noun';
        vm.noun = {};
        vm.pronouns = {};
        vm.adjective = {};
        vm.possessive = {};
        vm.possessiveAdjective = {};

        vm.editMode = $scope.editMode;
        vm.pushChange = $scope.pushChange;

        vm.childHandles = {};
        vm.childHandles.initNoun = {};
        vm.childHandles.initPronoun = {};
        // vm.childHandles.initAdjective = {};
        // vm.childHandles.initPossessive = {};
        // vm.childHandles.initPossessiveAdjective = {};

        vm.thisHandles = {};
        vm.thisHandles.initNoun = {};
        vm.thisHandles.initPronoun = {};
        // vm.thisHandles.initAdjective = {};
        // vm.thisHandles.initPossessive = {};
        // vm.thisHandles.initPossessiveAdjective = {};

        vm.editMode = function(input) {
            vm.Input = input;

            vm.noun.id = input.machine_name;
            vm.noun.label = input.label;
            vm.noun.value = input.value;
            vm.noun.class = input.class;
            vm.noun.displayValue = input.display_value;
            vm.childHandles.initNoun.invoke(vm.noun);

            vm.pronouns.label = 'Pronouns';
            vm.pronouns.value = input.pronoun_value;
            vm.pronouns.options = input.pronoun_options;
            vm.childHandles.initPronoun.invoke(
                vm.noun.id,
                vm.pronouns.label,
                vm.pronouns.value,
                vm.pronouns.options);

            // vm.adjective.label = 'Adjective';
            // vm.adjective.id = 'adjective';
            // vm.adjective.value = input.adjective_word;
            // vm.adjective.displayValue = input.adjective_display;
            // vm.childHandles.initAdjective.invoke(vm.adjective);

            // vm.possessive.label = 'Possessive Noun';
            // vm.possessive.id = 'possessive';
            // vm.possessive.value = input.possessive_word;
            // vm.possessive.class = input.possessive_class;
            // vm.possessive.displayValue = input.possessive_display;
            // vm.childHandles.initPossessive.invoke(vm.possessive);

            // vm.possessiveAdjective.label = 'Possessive Adjective';
            // vm.possessiveAdjective.id = 'possessive_adjective';
            // vm.possessiveAdjective.value = input.possessive_adjective_word;
            // vm.possessiveAdjective.displayValue = input.possessive_adjective_display;
            // vm.childHandles.initPossessiveAdjective.invoke(vm.possessiveAdjective);
        };

        vm.pushChangeToParent = function() {
            vm.pushChange(vm.noun.label);
        };

        vm.selectedNoun = function (data) {
            vm.noun = data;
            vm.Input.previous_value = angular.copy(vm.Input.value);
            vm.Input.value = parseInt(vm.noun.value);
            vm.Input.display_value = vm.noun.displayValue;
            vm.pushChangeToParent();
        }

        vm.selectedPronoun = function (dataId, value) {
            vm.Input.pronoun_value = value;
            vm.pushChangeToParent();
        }

        // vm.selectedAjective = function (data) {
        //     vm.adjective = data;
        //     vm.Input.adjective_value = parseInt(vm.adjective.value);
        //     vm.pushChangeToParent();
        // }

        // vm.selectedPossessive = function (data) {
        //     vm.possessive = data;
        //     vm.Input.possessive_value = parseInt(vm.possessive.value);
        //     vm.pushChangeToParent();
        // }

        // vm.selectedPossessiveAdjective = function (data) {
        //     vm.possessiveAdjective = data;
        //     vm.Input.possessive_adjective_value = parseInt(vm.possessiveAdjective.value);
        //     vm.pushChangeToParent();
        // }

        vm.getNouns = function (value) {
            return serverCallsService.getNouns(value);
        };

        // vm.getAdjectives = function (value) {
        //     return serverCallsService.getAdjectives(value, vm.noun.class);
        // };

        // vm.getPossessives = function (value) {
        //     return serverCallsService.getPossessives(value, vm.noun.class);
        // };

        // vm.getPossessiveAdjectives = function (value) {
        //     return serverCallsService.getAdjectives(value, vm.possessive.class);
        // };
    });
})();

(function() {
	var app = angular.module('sepedi_sentence_helper');
	app.controller('modalInstanceController', function ($scope, $modalInstance) {

		$scope.ok = function () {
			$modalInstance.close();
		};
	});
})();
// (function() {
// 	var app = angular.module('app');
// 	app.controller('modalHelpControl', function ($scope, $modal) {

// 		$scope.animationsEnabled = true;

// 		$scope.$on('help_for_component', function(e,control_help_id) {  
// 			$scope.open(control_help_id);	
// 		});

// 		$scope.open = function (controlHelpId,size) {
// 			$scope.controlHelpId = controlHelpId;
// 			var modalInstance = $modal.open({
// 				animation: $scope.animationsEnabled,
// 				templateUrl: 'local_help.html',
// 				controller: 'modalHelpInstance',
// 				size: size,
// 				scope:$scope
// 			});
// 		};
// 	});
// })();
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.controller('modalController', function ($rootScope, $scope, $modal) {

            $scope.animationsEnabled = true;

            $rootScope.$on('help_for_component', function(e, control_help_id) {  
                    $scope.openHelp(control_help_id);	
            });
            
            $rootScope.$on('notification_warning', function(e, control_help_id) {  
                    $scope.openWarning(control_help_id);
            });
            
            $scope.openHelp = function (controlId,size) {
                $scope.controlId = controlId;
                var modalSize = 'lg';
                var modalInstance = $modal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'local_help.html',
                        controller: 'modalInstanceController',
                        size: modalSize,
                        scope:$scope
                });
            };
            
            $scope.openWarning = function (controlId,size) {
                $scope.controlId = controlId;
                 var modalSize = 'lg';
                var modalInstance = $modal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'local_warning.html',
                        controller: 'modalInstanceController',
                        size: modalSize,
                        scope:$scope
                });
            };
    });
})();
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.controller('labelWordController',['$scope', '$timeout', 'sentenceService', 'inputService', 'serverCallsService', function ($scope, $timeout, sentenceService, inputService, serverCallsService) {
        $scope.type = 'label';
        sentenceService.bindController($scope);
        
        $scope.editMode = function(word) {
            $scope.word = word;
        };
        
        $scope.navigateTo = function(word,link) {
            if (word) {
                sentenceService.editMode(word);
            }
            else 
                sentenceService.editMode(link);
        };
    }]);
})();
/// <reference path="../../typings/angularjs/angular.d.ts"/>
(function() {
    var app = angular.module('sepedi_sentence_helper');
    app.controller('dictionaryEntryController',['$rootScope','$timeout','$filter','$scope', 'generalService', 'sentenceService', 'serverCallsService',
        function ($rootScope, $timeout, $filter, $scope, generalService, sentenceService, serverCallsService) {
        sentenceService.bindDictionaryEntryController($scope);
        var vm = this;
        vm.childHandles = {};
        vm.childHandles.noun = {};
        vm.childHandles.verb = {};
        //vm.childHandles['noun','verb'];
        vm.dictionaryHandles = {};
        //vm.dictionaryHandles.changeFromController = ...
        //vm.parentHandles.nounPush = ...

        $scope.getInputForSending = function () {
            var userInput = {};
            angular.forEach($scope.sentence.input, function(value, key) {
                if (value.type === "noun")
                    userInput[value.machine_name] = {
                        value: value.value,
                        previous_value: value.previous_value,
                        pronoun_value: value.pronoun_value,
                        adjective_value: value.adjective_value,
                        possessive_value: value.possessive_value,
                        possessive_adjective_value: value.possessive_adjective_value
                    };
                else if (value.type !== "label")
                    userInput[value.machine_name] = {value:value.value,previous_value:value.previous_value};
            });
            userInput.sentence_type = $scope.sentenceType;
            if ($scope.activeInputWord) {
                userInput.current_word = $scope.activeInputWord.machine_name;
            };
            if ($scope.optionsControllerChange) {
                userInput.option_changed = $scope.optionsControllerChange;
                $scope.optionsControllerChange = undefined;
            };
            return userInput;
        };

        $scope.pushWords = function () {
            sentenceService.pushWords();
        };

        $scope.updateInputs = function () {
            for (var keyIn in $scope.sentence.input) {
                for (var keyWo in $scope.sentence.words) {
                    if ($scope.sentence.input[keyIn].machine_name == $scope.sentence.words[keyWo].machine_name) {
                        if ($scope.sentence.words[keyWo].input_display) {
                                $scope.sentence.input[keyIn].display_value = $scope.sentence.words[keyWo].input_display;
                        }
                        if ($scope.sentence.words[keyWo].class) {
                            $scope.sentence.input[keyIn].class = $scope.sentence.words[keyWo].class;
                        }
                        if ($scope.sentence.words[keyWo].pronoun_options) {
                            var inPronouns = $filter('objectToArray')($scope.sentence.words[keyWo].pronoun_options);
                            $scope.sentence.input[keyIn].pronoun_value = $scope.sentence.words[keyWo].pronoun_value;
                            for(var i = 0; i<$scope.sentence.input[keyIn].pronoun_options.length; i++) {
                                $scope.sentence.input[keyIn].pronoun_options[i].label = inPronouns[i];
                            }
                        }

                        if ($scope.sentence.words[keyWo].adjective_word
                            || $scope.sentence.input[keyIn].adjective_word && !$scope.sentence.words[keyWo].adjective_word) {

                            $scope.sentence.input[keyIn].adjective_value = $scope.sentence.words[keyWo].adjective_value;
                            $scope.sentence.input[keyIn].adjective_word = $scope.sentence.words[keyWo].adjective_word;
                            $scope.sentence.input[keyIn].adjective_display = $scope.sentence.words[keyWo].adjective_display;
                        }

                        if ($scope.sentence.words[keyWo].possessive_word
                            || $scope.sentence.input[keyIn].possessive_word && !$scope.sentence.words[keyWo].possessive_word) {

                            $scope.sentence.input[keyIn].possessive_value = $scope.sentence.words[keyWo].possessive_value;
                            $scope.sentence.input[keyIn].possessive_class = $scope.sentence.words[keyWo].possessive_class;
                            $scope.sentence.input[keyIn].possessive_word = $scope.sentence.words[keyWo].possessive_word;
                            $scope.sentence.input[keyIn].possessive_display = $scope.sentence.words[keyWo].possessive_display;
                        }

                        if ($scope.sentence.words[keyWo].possessive_adjective_word
                            || $scope.sentence.input[keyIn].possessive_adjective_word && !$scope.sentence.words[keyWo].possessive_adjective_word) {

                            $scope.sentence.input[keyIn].possessive_adjectivee_value = $scope.sentence.words[keyWo].possessive_adjective_value;
                            $scope.sentence.input[keyIn].possessive_adjective_word = $scope.sentence.words[keyWo].possessive_adjective_word;
                            $scope.sentence.input[keyIn].possessive_adjective_display = $scope.sentence.words[keyWo].possessive_adjective_display;
                        }
                    }
                }
            }
        };

        $scope.updateDisplay = function () {
            $scope.updateInputs();
            sentenceService.updateDisplay();
        };

        $scope.getFirstEmptyInput = function () {
            for (var i=0; i< $scope.sentence.input.length; i++) {
                if (!$scope.sentence.input[i].value && $scope.sentence.input[i].value !== 0 && $scope.sentence.input[i].input !== 'label')
                    return i;
            }
            return -1;
        };

        $scope.isEmptyInput = function(i) {
            if (!$scope.sentence.input[i]) {
                return true;
            }
            else if (!$scope.sentence.input[i].value && $scope.sentence.input[i].value !== 0 && $scope.sentence.input[i].input !== 'label') {
                return true;
            }
            return false;
        };

        $scope.setWords = function () {
            if($scope.allowGetSentenceCall) {
                $rootScope.fetchingSentence = true;
                var input = $scope.getInputForSending();
                serverCallsService.getSentence(input).then(function (words) {
                    $scope.sentence.words = words;
                    $scope.sentence.isValid = !($scope.sentence.words.invalid_sentence);
                    $scope.sentence.disabledInputs = $scope.sentence.words.disable_inputs;
                    $scope.sentence.notification = $scope.sentence.words.notification;
                    if ($scope.sentence.notification) {
                        $scope.openWarning($scope.sentence.notification);
                    };
                    delete $scope.sentence.words.invalid_sentence;
                    delete $scope.sentence.words.disable_inputs;
                    delete $scope.sentence.words.notification;

                    angular.forEach($scope.sentence.words, function(value, key) {
                        $scope.sentence.words[key].machine_name = key;
                        if (!$scope.sentence.isValid && !($scope.sentence.words[key].value.length > 0)) {
                            $scope.sentence.words[key].value = '[Choose ' + $scope.sentence.words[key].label + ']';
                        };
                    });

                    if ($scope.sentence.isValid) {
                        var optionalInputs = [];
                        for (var key in $scope.sentence.input) {
                            if ($scope.isEmptyInput(key) && !(_.includes($scope.sentence.disabledInputs,$scope.sentence.input[key].machine_name))) {
                                optionalInputs.push($scope.sentence.input[key]);
                            };
                        };
                        sentenceService.sentenceSetAdditionalWord(optionalInputs);
                    };
                    $scope.pushWords();
                    $scope.updateDisplay();

                    var checkedWord = sentenceService.getCheckedWord();
                    var editIndex = $scope.getInputIndex(checkedWord);
                    if (checkedWord && editIndex) {
                        //$scope.resetShownInput($scope.sentence.input[editIndex].type);
                        $scope.editMode(checkedWord);
                    }
                    else if (checkedWord) {
                        //$scope.resetShownInput('label');
                        $scope.editMode(checkedWord);
                    }
                    else
                        $scope.resetShownInput();
                    if ($scope.changesMadeBackup) {
                        $scope.lastChangeMade = angular.extend([],$scope.changesMadeBackup);
                        $scope.changesMadeBackup = undefined;
                    }
                    $rootScope.fetchingSentence = false;
                });
            };
        };

        $scope.setup = function (sentenceType) {
            serverCallsService.getSetup(sentenceType).then(function (setup) {
                $scope.changesMadeBackup = angular.extend([], $scope.lastChangeMade);
                if ($scope.sentence) {
                    for (var i=0; i < $scope.sentence.input.length; i++) {
                        var index = _.findIndex(setup.sentence.input, function (inInput) {
                            return inInput.machine_name === $scope.sentence.input[i].machine_name;
                        });
                        if (index < 0) {
                            $scope.changesMadeBackup = _.without($scope.changesMadeBackup, $scope.sentence.input[i].machine_name);
                        }
                        else {
                            setup.sentence.input[index].value = $scope.sentence.input[i].value;
                            setup.sentence.input[index].display_value = $scope.sentence.input[i].display_value;
                            setup.sentence.input[index].pronoun_value = $scope.sentence.input[i].pronoun_value;
                            setup.sentence.input[index].adjective_value = $scope.sentence.input[i].adjective_value;
                            setup.sentence.input[index].possessive_value = $scope.sentence.input[i].possessive_value;
                        };
                    };
                };

                $scope.sentence = setup.sentence;
                var sentenceOptionsInputs = [];
                if ($scope.sentence.input[0].machine_name === 'tense' && $scope.sentence.input[1].machine_name === 'posneg') {
                    sentenceOptionsInputs.push($scope.sentence.input[0]);
                    sentenceOptionsInputs.push($scope.sentence.input[1]);
                };
                if ($scope.sentence.input[0].machine_name === 'posneg') {
                    sentenceOptionsInputs.push($scope.sentence.input[0]);
                };
                sentenceService.pushSentenceOptions(sentenceOptionsInputs);
                $scope.allowGetSentenceCall = true;
                $scope.setWords();
            });
        };

        $scope.resetShownInput = function(show) {
            for (var key in $scope.showControls) {
                $scope.showControls[key] = false;
            }
            if (show) {
                $timeout(function() {
                    $scope.$apply($scope.showControls[show] = true);
                    //sentenceService.setCheckedWord();
                });
            }
            if ($scope.activeInputWord && $scope.activeInputWord.combo) {
                 $scope.showControls['label'] = true;
                 sentenceService.pushEditToController($scope.activeInputWord, 'label');
            }
        };

        $scope.getInputIndex = function (word) {
            if (!word)
                return undefined;
            var indexForEdit;
            for (var key in $scope.sentence.input) {
                if ($scope.sentence.input[key].machine_name === word.machine_name) {
                    indexForEdit = key;
                    break;
                };
            };
            return indexForEdit;
        };

        $scope.editMode = function(word) {
            if (word === 'optional_controllers') {
                $rootScope.triggerAnimation.tense = true;
                $timeout(function() {
                    $rootScope.triggerAnimation.tense = false;
                });
                return;
            };
            $scope.allowGetSentenceCall = false;
            sentenceService.updateChechedWord(word);
            $scope.activeInputWord = word;
            $scope.resetShownInput();
            var editIndex = $scope.getInputIndex(word);
            if ($scope.sentence.input[editIndex]) {
                var type = $scope.sentence.input[editIndex].type;
                if (type != 'noun' && type != 'verb') {
                    sentenceService.pushEditToController($scope.sentence.input[editIndex], type);
                }
                else {
                    vm.childHandles[$scope.sentence.input[editIndex].type].invoke($scope.sentence.input[editIndex]);
                }
                $scope.resetShownInput(type);
            }
            else {
                var type = 'label';
                var tempWord = {};
                tempWord.machine_name = word.link;
                editIndex = $scope.getInputIndex(tempWord);
                word.parentInput = $scope.sentence.input[editIndex];
                sentenceService.pushEditToController(word, type);
                $scope.resetShownInput(type);
            };
            $scope.allowGetSentenceCall = true;
        };

        $scope.editModeViaName = function(machine_name) {
            var word = _.find($scope.sentence.words, function (word) {
                            return word.machine_name === machine_name;
                        });
            $scope.editMode(word);
        };

        $scope.changeFromController = function (machine_name) {
            if (machine_name && machine_name !== 'tense' && machine_name !== 'posneg') {
                $scope.lastChangeMade = _.without($scope.lastChangeMade, machine_name);
                $scope.lastChangeMade.push(machine_name);
            }
            else if (machine_name === 'tense' || machine_name === 'posneg') {
                $scope.optionsControllerChange = machine_name;
            };
            $scope.setWords();
        };
        vm.dictionaryHandles.changeFromController = $scope.changeFromController;

        $scope.undo = function (undoAll) {
            if (undoAll) {
                $scope.lastChangeMade = [];
                $scope.setupSentenceType($scope.sentenceType);
            }
            for (var keyIn in $scope.sentence.input) {
                if ($scope.sentence.input[keyIn].machine_name !== 'tense'
                    && $scope.sentence.input[keyIn].machine_name !== 'posneg'
                    && (undoAll || $scope.lastChangeMade[$scope.lastChangeMade.length - 1] === $scope.sentence.input[keyIn].machine_name)) {
                    $scope.sentence.input[keyIn].value = '';
                    if ($scope.sentence.input[keyIn].display_value)
                        $scope.sentence.input[keyIn].display_value = '';
                    if (!undoAll) {
                        $scope.lastChangeMade.pop();
                        break;
                    }
                };
            };
            $scope.setWords();
            $scope.resetShownInput();
        };

        $scope.getWords = function () {
            return $scope.sentence.words;
        };

        $scope.getInputs = function () {
            return $scope.sentence.input;
        };

        $scope.openHelp = function (options) {
            generalService.openHelp(options);
        };

        $scope.openWarning = function (options) {
            generalService.openWarning(options);
        };

        $scope.setupSentenceType = function(type)
        {
            $scope.sentenceType = type || 'indicative';

            $scope.setup($scope.sentenceType);
            $scope.showControls = [];
            $scope.showControls['noun'] = false;
            $scope.showControls['verb'] = false;
            $scope.showControls['label'] = false;
            //$scope.lastChangeMade = [];
        };

        $scope.sentenceTypeList = [];
        $scope.sentenceTypeList.push({label:'Indicative', machine_name:'indicative', shortDescription:'STATEMENTS', description:'<h4>STATEMENTS<h4>'});
        $scope.sentenceTypeList.push({label:'Situative', machine_name:'situative', shortDescription:'IF/WHILE', description:'<h4>IF/WHILE<h4>'});
        $scope.sentenceTypeList.push({label:'Relative', machine_name:'relative', shortDescription:'WHO/WHAT (IS DOING SOMETHING)', description:'<h4>WHO/WHAT (IS DOING SOMETHING)</h4>'});
        $scope.sentenceTypeList.push({label:'Subjunctive', machine_name:'subjunctive', shortDescription:'MUST (DO SOMETHING)', description:'<h4>MUST (DO SOMETHING)<h4>'});
        $scope.sentenceTypeList.push({label:'Consecutive', machine_name:'consecutive', shortDescription:'AND THEN (DO/DID SOMETHING)', description:'<h4>AND THEN (DO/DID SOMETHING)<h4>'});
        $scope.sentenceTypeList.push({label:'Infinitive', machine_name:'infinitive', shortDescription:'TO (DO SOMETHING)', description:'<h4>TO (DO SOMETHING)<h4>'});
        $scope.sentenceTypeList.push({label:'Imperative', machine_name:'imperative', shortDescription:'(DO SOMETHING)', description:'<h4>(DO SOMETHING)<h4>'});
        $scope.sentenceTypeList.push({label:'Habitual', machine_name:'habitual', shortDescription:'USUALLY (DO SOMETHING)', description:'<h4>USUALLY (DO SOMETHING)<h4>'});

        $scope.lastChangeMade = [];
        $scope.getSentenceTypes = function () {
            return $scope.sentenceTypeList;
        };

        // $rootScope.triggerAnimation = {};
        // $rootScope.triggerAnimation.tense = true;

    }]);
})();

angular.module("templates").run(["$templateCache", function($templateCache) {$templateCache.put("app/views/templates/help/about_prinsloos_help.html","<div style=\"text-align: center;\"><div><h4>Prof D.J. Prinsloo, University of Pretoria, danie.prinsloo@up.ac.za</h4></div><div><h4>Daniel Prinsloo, Entelect, dprinsloo@gmail.com</h4></div><div><h4>Jacobus Prinsloo, Aerosud, jacobus.rezist@gmail.com</h4></div><br><h4>Scientific e-Lexicography for Africa <img name=\"SeLA logo\" alt=\"The SeLA logo was designed by Karsten Spindler\" hcpace=\"30mm\" align=\"left\" width=\"28%\" src=\"img/sela_logo_color_transparent.gif\"><p>SeLA is concerned with methods for the preparation of electronic dictionaries for South Africa; both, theoretical and practical aspects are covered; we use methods from linguistics, language technology and information science. The focus is on South Africa´s multilingualism, on specialized terminology, and on new concepts for user interfaces of electronic dictionaries. SeLA involves both North/South- and South/South-cooperation, the joint development of concepts for university teaching in lexicography, student and researcher exchange, and accompanying research in intercultural (scientific) communication.</p><a target=\"blank\" href=\"http://www.unisa.ac.za/default.html\"><img src=\"img/LogoUNISA.gif\"></a> <a target=\"blank\" href=\"http://www.uni-hildesheim.de/\"><img src=\"img/LogoUHI.gif\"></a> <a target=\"blank\" href=\"http://www.unam.na\"><img src=\"img/LogoUNAM-v2.gif\"></a> <a target=\"blank\" href=\"http://stbweb01.stb.sun.ac.za/\"><img src=\"img/LogoSTB.gif\"></a> <a target=\"blank\" href=\"http://www.up.ac.za/default.html\"><img src=\"img/LogoUP.gif\"></a><br><div><h4>Thank you for yor time! Rena re a leboga!</h4><br><br></div><div class=\"help_image_div\"><img class=\"help_image\" animation-gifs-wrapper=\"\" src=\"gifs/thank_you.gif\" alt=\"Thank you!\" align=\"middle\"></div><br><div>Using <a href=\"http://freezeframe.chrisantonellis.com\">FreezeFrame</a> by <a href=\"http://www.chrisantonellis.com\">Chris Antonellis</a></div></h4></div>");
$templateCache.put("app/views/templates/help/adjective_help.html","<div style=\"text-align: center;\"><h4>Adjectives:</h4><p>Adjectives consist of four parts for classes 1-7 and 14-18 and of three parts for classes 8 -10.</p><br><h5>Formula for classes 1-7 and 14-18: NOUN. + DEM + CP + STEM</h5><p>Class 1 monna yo mo-golo ‘A big man’</p><p>Class 2 banna ba ba-golo ‘Big men’</p><p>Class 5 lesogana le le-golo ‘A big young man’</p><p>Class 6 masogana a ma-golo ‘Big young men’</p><p>Class 7 selepe se se-golo ‘A big axe’</p><br><p>Class 14 bogobe bjo bogolo ‘Big porridge’</p><br><p>----------------------------------------------------------------</p><br><h5>Formula for classes 8 to 10: NOUN. + DEM + strengthened STEM</h5><p>Class 8 dilepe tše kgolo</p><p>Class 9 nku ye kgolo</p><p>Class 10 dinku tše kgolo</p><p></p></div>");
$templateCache.put("app/views/templates/help/consecutive_help.html","<div style=\"text-align: center;\"><h4>Consecutive mood:</h4><div><p><span>Consecutive expresses: <b>processes that follow each other chronologically</b></span></p><p><span>No tense distinction</span></p><p><span>&nbsp;</span></p><p><span>Most common structure: noun + subject concord + verb + object</span></p><p><span>Example: <b>Positive</b>:<br>monna a reka puku</span></p><p><span>‘Then the man buy<span>s</span> a book.’</span></p><p><span><b>Negative</b>:<br>Monna a <b>se</b> rek<b>e</b> puku. ‘Then the man does not buy a book.’</span></p><p><span>Negation strategy: <b>se</b> … verb ends in <b>-e</b></span></p><br><p><span>Can occur with direct and indirect object:</span></p><p><span>Monna a rekela bana(indirect object) puku(direct object).</span></p><p><span>‘The man then buys for the children a book!</span></p><br><p><span>Nouns can be replaced by <b>pronouns</b>:</span></p><p><span>Example(<b>bana</b>): Monna a rekela <b>bona</b> puku.</span></p><br><p><span>Object nouns can also be replaced by object concords:</span></p><p><span>Example: Monna a <b>ba</b> rekela puku.</span></p><p><span>&nbsp;</span></p><p><span>The alternative concord is used in the consecutive:</span></p><p><span>(Alt. concords: 1ps: ka, 1pp: ra, 2ps: wa, 2pp: la, cl.1: a, cl.2: ba, cl.3: wa, cl.4: ya, cl.5: la, cl.6: a, cl.7: sa, cl.8: tša, cl.9: ya, cl.10: tša, cl.14: bja, cl.15-18 and locatives: gwa)</span>\'</p></div></div>");
$templateCache.put("app/views/templates/help/direct_object_noun_help.html","<div style=\"text-align: center;\"><h4>Direct object noun</h4><p>The noun following the verb Example: monna o rekile <b>dipuku</b> ‘The man bought <b>books</b>’</p><p></p></div>");
$templateCache.put("app/views/templates/help/generic_typeahead_help.html","<p>GENERIC HELP</p><p></p>");
$templateCache.put("app/views/templates/help/habitual_help.html","<div style=\"text-align: center;\"><h4>Habitual mood:</h4><div><p>Habitual expresses: things that<strong>usually happen</strong></p><p>No tense distinction</p><p>Most common structure: noun + subject concord +verb + object</p><p>Example: <strong>Positive</strong>: monna a rek<strong>e</strong> puku</p><p>‘The man usually buys a book.’</p><p><strong>Negative</strong> : Monna a <strong>se</strong> rek<strong>e</strong> puku. ‘The man usually does not buy a book,’</p><p>Negation strategy: <strong>se</strong> … verb ends in <strong>-e</strong></p><p>Can occur with direct and indirect object:</p><p>Monna a rekele bana(indirect object) puku(direct object).</p><br><p>‘The man usually buys for the children a book.</p><p>Nouns can be replaced by <strong>pronouns</strong>:</p><p>Example (<strong>bana</strong>): Monna a rekele <strong>bona</strong> puku.</p><p>Object nouns can also be replaced by object concords:</p><p>Example: Monna a <strong>ba</strong> rekele puku.</p></div></div>");
$templateCache.put("app/views/templates/help/imperative_help.html","<div style=\"text-align: center;\"><h4>Imperative mood:</h4><div><br><p>Imperative expresses: <strong>commands</strong></p><p>No tense distinction</p><p>Most common structure: verb + object</p><br><p>Example: <strong>Positive</strong>: Reka puku!</p><p>&lsquo;Buy a book!&rsquo;</p><p><strong>Negative</strong>: <strong>se</strong> rek<strong>e</strong> puku. &lsquo;do not buy a book!</p><p>Negation strategy: <strong>se</strong> &hellip; verb ends in <strong>-e</strong></p><p>Can occur with direct and indirect object:</p><p>Rekela bana(indirect object) puku(direct object)!</p><p>&lsquo;Buy for the children a book!</p><br><p>Nouns can be replaced by <strong>pronouns</strong>:</p><p>Example (<strong>bana</strong>): Rekela <strong>bona</strong> puku!</p><p>Object nouns can also be replaced by object concords:</p><p>Example: Ba rekele puku!</p></div></div>");
$templateCache.put("app/views/templates/help/indicative_help.html","<div style=\"text-align: center;\"><h4>Indicative mood:</h4><br><p>Indicative expresses: <strong>statements</strong></p><br><p><strong>Present</strong></p><p>Most common structure: Noun + subject concord + verb + object</p><p>Example: <strong>Positive</strong>: Monna o reka puku. &lsquo;The man buys a book&rsquo;</p><p><strong>Negative</strong>: Monna <strong>ga</strong> a rek<strong>e</strong> puku. &lsquo;The man does not buy a book&rsquo;</p><p>Negation strategy: <strong>ga</strong> &hellip; verb ends in <strong>-e</strong></p><p>If nothing follows the verb: insert present tense marker &ldquo;<strong>a</strong>&rdquo;:</p><p>Monna o <strong>a</strong> reka &lsquo;The man buys&rsquo;</p><p>In negative subject concord class 1 changes from o to <strong>a</strong>:</p><p>Monna ga <strong>a</strong> reke puku</p><p>Can occur with direct and indirect object:</p><p>Monna o rekela bana (indirect object) puku (direct object)</p><br><p>&lsquo;The man buys for the children a book.</p><p>Nouns can be replaced by <strong>pronouns</strong>:</p><p>Example (<strong>bana</strong>): Monna o rekela <strong>bona</strong> puku</p><p>Object nouns can also be replaced by object concords:</p><p>Example: Monna o <strong>ba</strong> rekela puku</p><br><p><strong>Future</strong></p><p>Most common structure: Noun + subject concord + fut. +verb + object</p><p>Example: <strong>Positive</strong>: Monna o tlo reka puku.</p><p>&lsquo;The man will buy a book&rsquo;</p><p><strong>Negative</strong>: Monna a <strong>ka se</strong> rek<strong>e</strong> puku. &lsquo;The man will not buy a book&rsquo;</p><p>Negation strategy: <strong>ka se</strong> &hellip; verb ends in <strong>-e</strong></p><p>In negative subject concord class 1 changes from o to <strong>a</strong></p><p>The combination ke = I + ka se becomes <strong>nka</strong> se</p><p><strong>Nka</strong>se reke puku &lsquo;I shall not buy the book&rsquo;</p><br><p><strong>Past</strong></p><p>Most common structure: Noun + subject concord + verb + object</p><p>Example: <strong>Positive</strong>: Monna o rekile puku. &lsquo;The man bought a book&rsquo;</p><p><strong>Negative</strong>: Monna <strong>ga se a reka</strong> puku. &lsquo;The man did not buy a book&rsquo;</p><p>Negation strategy: <strong>ga se</strong> + <strong>alternative concord</strong> + <strong>verb back to the present tense</strong></p><p>(Alt. concords: 1ps: ka, 1pp: ra, 2ps: wa, 2pp: la, cl.1: a, cl.2: ba, cl.3: wa, cl.4: ya, cl.5: la, cl.6: a, cl.7: sa, cl.8: t&scaron;a, cl.9: ya, cl.10: t&scaron;a, cl.14: bja, cl.15-18 and locatives: gwa)</p></div>");
$templateCache.put("app/views/templates/help/indirect_object_noun_help.html","<div style=\"text-align: center;\"><h4>Indirect object noun</h4><p>The noun <b>for which</b> a process is performed: Example: Monna o rekela <b>mosadi</b> diaparo. ‘The man buys for <b>the woman</b> the clothes’</p><p></p></div>");
$templateCache.put("app/views/templates/help/infinitive_help.html","<div style=\"text-align: center;\"><h4>Infinitive mood:</h4><div><br><p>Infinitive expresses: <strong>to do something</strong></p><p>No tense distinction</p><br><p>Most common structure: Infinitive prefix + verb + object</p><p>Example: <strong>Positive</strong>: Go reka puku.</p><p>&lsquo;To buy a book&rsquo;</p><br><p><strong>Negative</strong>: Go <strong>se</strong> rek<strong>e</strong> puku. &lsquo;not to buy a book&rsquo;</p><p>Negation strategy: <strong>se</strong> &hellip; verb ends in <strong>-e</strong></p><br><p>Can occur with direct and indirect object:</p><p>Ge rekela bana(indirect object) puku(direct object)</p><p>&lsquo;To buy for the children a book.</p><br><p>Nouns can be replaced by <strong>pronouns</strong>:</p><p>Example (<strong>bana</strong>): Go rekela <strong>bona</strong> puku</p><p>Object nouns can also be replaced by object concords:</p><p>Example: Go <strong>ba</strong> rekela puku</p></div></div>");
$templateCache.put("app/views/templates/help/main_instructions_help.html","<div style=\"text-align: center;\"><h4>Indicative mood:</h4><p>Making statements in the present, future and past in the positive or negative:</p><br><p><b>Present tense</b></p><p>Example: monna o reka dipuku \"The man buys books\"</p><br><p><b>Future tense</b></p><p>Example: monna o tlo reka dipuku \"The man will buy books\"</p><br><p><b>Past tense tense</b></p><p>Example: monna o rekile dipuku \"The man bought books\"</p><div class=\"help_image_div\"><img class=\"help_image\" preload-image=\"\" animation-gifs-wrapper=\"\" ng-src=\"gifs/full_example.gif\" alt=\"Thank you!\" align=\"middle\"></div><p></p></div>");
$templateCache.put("app/views/templates/help/main_instructions_indicative_help.html","");
$templateCache.put("app/views/templates/help/posneg_help.html","<div style=\"text-align: center;\"><h4>Negative morphemes:</h4><p>Words used to express sentences in the negative:</p><br><p>Lesogana le bolela Sepedi ‘The young man speaks Sepedi’</p><p>Lesogana ga le bolele Sepedi ‘The young man does not speak Sepedi’</p><br><p>Lesogana le tlo bolela Sepedi ‘The young man will speak Sepedi’</p><p>Lesogana le ka se bolele Sepedi ‘The young man will not speak Sepedi’</p><br><p>Lesogana le boletše Sepedi ‘The young man spoke Sepedi’</p><p>Lesogana ga se la bolela Sepedi ‘The young man did not speak Sepedi’</p><p></p></div><div class=\"help_image_div\"><img class=\"help_image\" animation-gifs-wrapper=\"\" src=\"gifs/posneg.gif\" alt=\"Thank you!\" align=\"middle\"></div>");
$templateCache.put("app/views/templates/help/present_tense_marker_help.html","<div style=\"text-align: center;\"><h4>Present tense marker:</h4><p>An “a” to be inserted in all sentences in the present tense, positive if nothing follows the verb Example: monna o a sepela ‘The man is walking’</p><p></p></div>");
$templateCache.put("app/views/templates/help/relative_help.html","<div style=\"text-align: center;\"><h4>Relative mood:</h4><div><p>Relative expresses: <strong>who/what is doing something</strong></p><br><p><strong>Present</strong></p><p>Most common structure: Noun + demonstrative +subject concord + verb + go +object</p><p>Example: <strong>Positive</strong>: Monna <strong>yo</strong> a reka<strong>go</strong> puku.</p><p>&lsquo;The man who buys a book&rsquo;</p><br><p><strong>Negative</strong>: Monna yo a <strong>sa</strong> rek<strong>e</strong>go puku. &lsquo;The man who does not buy a book&rsquo;</p><p>Negation strategy: <strong>sa</strong> &hellip; verb ends in <strong>-e</strong></p><br><p>Can occur with direct and indirect object:</p><p>Monna yo a rekelago bana puku</p><p>indirect object) direct object</p><p>&lsquo;The man who buys for the children a book.</p><br><p>Nouns can be replaced by <strong>pronouns</strong>:</p><p>Example (<strong>bana</strong>): Monna yo a rekelago <strong>bona</strong> puku</p><p>Object nouns can also be replaced by object concords:</p><p>Example: Monna yo a <strong>ba</strong> rekelago puku</p><br><p><strong>Future</strong></p><p>Most common structure: Noun + demonstrative + subject concord + fut.+ go +verb + object</p><p>Example: <strong>Positive</strong>: Monna yo a tlogo reka puku.</p><p>&lsquo;The man who will buy a book&rsquo;</p><p><strong>Negative</strong>: Monna yo a <strong>ka se</strong> rek<strong>e</strong>go puku. &lsquo;The man who will not buy a book&rsquo;</p><p>Negation strategy: <strong>ka se</strong> &hellip; verb ends in <strong>-e</strong></p><p>In negative subject concord class 1 changes from o to <strong>a</strong></p><p>The combination ke = I + ka se becomes <strong>nka</strong> se</p><p><strong>Nka</strong>se reke puku &lsquo;I shall not buy the book&rsquo;</p><br><p><strong>Past</strong></p><p>Most common structure: Noun + demonstrative + subject concord + verb + go + object</p><p>Example: <strong>Positive</strong>: Monna yo a rekilego puku. &lsquo;The man who bought a book&rsquo;</p><p><strong>Negative</strong>: Monna yo a<strong>sa reka</strong>go puku. &lsquo;The man who did not buy a book&rsquo;</p><p>Negation strategy: <strong>sa</strong> + <strong>verb back to the present tense</strong></p></div></div>");
$templateCache.put("app/views/templates/help/situative_help.html","<div style=\"text-align: center;\"><h4>Situative mood:</h4><div><br><p>Situative expresses: <strong>conditions: if &hellip;. (</strong>or something that happens simultaneously with another process).<br>Often preceded by <strong>ge</strong> &lsquo;if&rsquo;</p><br><p><strong>Present</strong></p><p>Most common structure: Noun + subject concord + verb + object</p><p>Example: <strong>Positive</strong>: Ge monna a reka puku.</p><p>&lsquo;If the man buys a book&rsquo;</p><p><strong>Negative</strong>: ge monna a <strong>sa</strong> rek<strong>e</strong> puku. &lsquo;If the man does not buy a book&rsquo;</p><p>Negation strategy: <strong>sa</strong> &hellip; verb ends in <strong>-e</strong></p><p>Can occur with direct and indirect object:</p><p>Ge monna a rekela bana(indirect object) puku(direct object)</p><br><p>&lsquo;If the man buys for the children a book.</p><p>Nouns can be replaced by <strong>pronouns</strong>:</p><p>Example (<strong>bana</strong>): Ge monna a rekela <strong>bona</strong> puku</p><p>Object nouns can also be replaced by object concords:</p><p>Example: Ge monna a <strong>ba</strong> rekela puku</p><br><p><strong>Future</strong></p><p>Most common structure: Noun + subject concord + fut. +verb + object</p><p>Example: <strong>Positive</strong>: Ge monna a tlo reka puku.</p><p>&lsquo;If the man will buy a book&rsquo;</p><p><strong>Negative</strong>: Ge monna a <strong>ka se</strong> rek<strong>e</strong> puku. &lsquo;If the man will not buy a book&rsquo;</p><p>Negation strategy: <strong>ka se</strong> &hellip; verb ends in <strong>-e</strong></p><br><p>The combination ke = I + ka se becomes <strong>nka</strong> se</p><p>Ge <strong>nka</strong>se reke puku &lsquo;If I shall not buy the book&rsquo;</p><br><p><strong>Past</strong></p><p>Most common structure: Noun + subject concord + verb + object</p><p>Example: <strong>Positive</strong>: Ge monna a rekile puku. &lsquo;If the man bought a book&rsquo;</p><p><strong>Negative</strong>: Ge monna a<strong>sa reka</strong> puku. &lsquo;If the man did not buy a book&rsquo;</p><p>Negation strategy: <strong>sa</strong> + <strong>verb back to the present tense</strong></p></div></div>");
$templateCache.put("app/views/templates/help/subject_concord_help.html","<div style=\"text-align: center;\"><h4>Subject concord:</h4><p>The morpheme linking the noun with the verb Example: monna o reka dipuku ‘The man buys books’</p><p></p></div>");
$templateCache.put("app/views/templates/help/subject_noun_help.html","<div style=\"text-align: center;\"><h4>Subject noun:</h4><p>First noun in the phrase acting of the subject of the sentence::</p><p>Example: <b>monna</b> o reka dipuku ‘<b>The man</b> buys books’</p><br><p>Is used to determine the Subject concord</p><p></p></div><div class=\"help_image_div\"><img class=\"help_image\" animation-gifs-wrapper=\"\" src=\"gifs/subject_noun.gif\" alt=\"Thank you!\" align=\"middle\"></div>");
$templateCache.put("app/views/templates/help/subject_noun_pronoun_help.html","<p>SUBJECT NOUN PRONOUN HELP</p><p></p>");
$templateCache.put("app/views/templates/help/subjunctive_help.html","<div style=\"text-align: center;\"><h4>Subjunctive mood:</h4><div><br><p>Subjunctive expresses: <strong>must do something</strong></p><br><p>No tense distinction</p><p>Most common structure: (gore) noun + subject concord +verb + object</p><br><p>Example: <strong>Positive</strong>: (Gore) monna a rek<strong>e</strong> puku</p><p>&lsquo;So that the man (must) buy(s) a book.&rsquo;</p><br><p><strong>Negative</strong>: (Gore monna) a <strong>se</strong> rek<strong>e</strong> puku. &lsquo;So that the man does not buy a book.</p><p>Negation strategy: <strong>se</strong> &hellip; verb ends in <strong>-e</strong></p><p>Can occur with direct and indirect object:</p><p>(Gore) monna a rekele bana(indirect object) puku(direct object).</p><br><p>&lsquo;So that the man (must) buy(s) for the children a book.</p><br><p>Nouns can be replaced by <strong>pronouns</strong>:</p><p>Example (<strong>bana</strong>): (Gore) monna a rekele <strong>bona</strong> puku.</p><p>Object nouns can also be replaced by object concords:</p><p>Example: (Gore) monna a ba rekele puku.</p></div></div>");
$templateCache.put("app/views/templates/help/tense_help.html","<div style=\"text-align: center;\"><h4>Tense Help:</h4><p><b>Present tense</b></p><p>Typically subject noun + subject concord + verb + object</p><p>Example: monna o reka dipuku \"The man buys books\"</p><br><p><b>Future tense</b></p><p>Typically subject noun + subject concord + tlo + verb + object</p><p>Example: monna o tlo reka dipuku \"The man will buy books\"</p><br><p><b>Past tense</b></p><p>Typically subject noun + subject concord + verb (in the past tense) + object</p><p>Example: monna o rekile dipuku \"The man bought books\"</p><p></p></div><div class=\"help_image_div\"><img class=\"help_image\" animation-gifs-wrapper=\"\" src=\"gifs/tense.gif\" alt=\"Thank you!\" align=\"middle\"></div>");
$templateCache.put("app/views/templates/help/tense_morpheme_help.html","<p>PRINSLOOS</p><p><span class=\"btn btn-large btn-info\" style=\"float:right;\" ng-click=\"ok()\">Ok</span></p>");
$templateCache.put("app/views/templates/help/verb_help.html","<div style=\"text-align: center;\"><h4>Verb:</h4><p>The word expressing the action of the sentence:</p><p>Example: monna o reka dipuku ‘The man buys books’</p><br><p><b>Intransitive verb</b></p><p>A verb that does not take any objects:</p><p>Example: Monna o a sepela ‘The man is walking’</p><br><p><b>Transitive verb</b></p><p>A verb that can occur with an object</p><p>Example: Lesogana le ngwala lengwalo ‘The young man is writing a letter’</p><br><p><b>Double transitive verb</b></p><p>A verb that can occur with two objects:</p><p>Example: Lesogana le rekela mosadi diaparo ‘The young man buys for the woman clothes’/p><br></p></div><div class=\"help_image_div\"><img class=\"help_image\" animation-gifs-wrapper=\"\" src=\"gifs/verb.gif\" alt=\"Thank you!\" align=\"middle\"></div>");
$templateCache.put("app/views/templates/input/centreComponentContainer.html","<div class=\"col-xs-12 text-center\"><div ng-transclude=\"\"></div></div>");
$templateCache.put("app/views/templates/input/componentContainer.html","<div class=\"col-xs-12 col-sm-9 col-sm-offset-3\"><div id=\"transclude-placeholder\"></div></div>");
$templateCache.put("app/views/templates/input/fullRowDisplaySetContainer.html","<div class=\"row\"><div class=\"col-xs-12\" style=\"text-align: center;\"><div ng-transclude=\"\"></div></div></div>");
$templateCache.put("app/views/templates/input/inputSetContainer.html","<div class=\"row\"><div class=\"col-xs-12 col-sm-8\"><div id=\"transclude-placeholder\"></div></div></div>");
$templateCache.put("app/views/templates/input/labelWord.html","<div><full-row-display-set-container><div ng-controller=\"labelWordController\" ng-init=\"setType(\'label\')\"><div ng-show=\"!word.add_info_label\">{{word.label}}: <span class=\"btn btn-info\">{{word.value}}</span> <span ng-hide=\"word.label_display\">generated from <span class=\"btn btn-success\" ng-click=\"navigateTo(word.parentInput,word.link)\">{{word.parentInput.label}}{{word.link_label}}</span></span> <span ng-show=\"word.label_display\">{{word.label_display}}</span> <span class=\"btn btn-large btn-info\" ng-click=\"openHelp(word.machine_name)\"><i class=\"fa fa-question-circle fa-lg\"></i></span></div><div ng-show=\"word.add_info_label\"><span>{{word.add_info_label}}:</span> <span class=\"btn btn-info\">{{word.add_info_value}}</span> <span>{{word.add_info_label_between}}</span> <span class=\"btn btn-success\">{{word.add_info_link_label}}</span> <span>{{word.add_info_label_end}}</span> <span class=\"btn btn-primary\">{{word.add_info_combined}}</span> <span class=\"btn btn-large btn-info\" ng-click=\"openHelp(word.add_info_help)\"><i class=\"fa fa-question-circle fa-lg\"></i></span></div></div></full-row-display-set-container></div>");
$templateCache.put("app/views/templates/input/nounInput.html","<div><input-set-container><type-ahead-input type=\"{{\'noun\'}}\" data=\"vm.noun.data\" push-change=\"vm.noun.pushChange\" get-list=\"vm.noun.data.get\"></type-ahead-input></input-set-container><input-set-container><radio-button-group-input type=\"{{\'noun\'}}\" data=\"vm.noun.pronoun.data\" push-change=\"vm.noun.pronoun.pushChange\"></radio-button-group-input></input-set-container><input-set-container ng-show=\"!vm.noun.data.displayValue\"><p><b>Select a Noun</b> before an <b>Adjective</b> and/or <b>Possessive Noun</b> and/or <b>Possessive Adjective</b></p></input-set-container><input-set-container ng-show=\"!!vm.noun.data.displayValue\"><type-ahead-input type=\"{{\'adjective\'}}\" data=\"vm.noun.adjective.data\" push-change=\"vm.noun.adjective.pushChange\" get-list=\"vm.noun.adjective.data.get\"></type-ahead-input></input-set-container></div>");
$templateCache.put("app/views/templates/input/nounInputContainer.html","<div><input-set-container><type-ahead-input type=\"{{\'noun\'}}\" init=\"vm.childHandles.initNoun\" push-change=\"vm.selectedNoun\" get-words=\"vm.getNouns\"></type-ahead-input></input-set-container><input-set-container><radio-button-group-input init=\"vm.childHandles.initPronoun\" push-change=\"vm.selectedPronoun\"></radio-button-group-input></input-set-container></div>");
$templateCache.put("app/views/templates/input/radioButtonGroupInput.html","<div class=\"column\"><div id=\"noun_pronoun_group\" class=\"\"><label for=\"noun_pronoun_group\">{{vm.data_label}}:</label> <span ng-repeat=\"option in vm.data_options\" ng-show=\"option.label && option.label.length > 0\"><button class=\"btn btn-xs btn-success btn-success-gray\" ng-model=\"option.checked\" ng-click=\"vm.selectionChanged(option.value)\" btn-checkbox=\"\" btn-checkbox-true=\"1\" btn-checkbox-false=\"0\">{{option.label}}</button></span></div></div>");
$templateCache.put("app/views/templates/input/sentenceInputStep.html","<div ng-controller=\"sentenceInputStepDisplayController\"><button class=\"btn btn-success\" ng-click=\"editMode(machine_name)\" data-ng-disabled=\"disabled\">{{computedLabel}}</button> <span>-</span> <span>{{computedValue}}</span></div>");
$templateCache.put("app/views/templates/input/sentenceInterface.html","<div><full-row-display-set-container><h4>Sentence: <i ng-show=\"$root.fetchingSentence\" class=\"no-animate text-success fa fa-refresh fa-spin fa-lg\"></i></h4><div id=\"sentence_words_group\" ng-controller=\"sentenceInterfaceController\" style=\"margin: 10px;\"><button ng-show=\"words.length > 0\" ng-repeat=\"word in words | orderBy : \'order\'\" btn-checkbox=\"\" ng-click=\"editMode(word)\" ng-model=\"word.selected\" ng-change=\"setChecked(word)\" ng-class=\"{\'active\':word.selected}\" class=\"btn btn-default {{word.combo ? \'sentence-combo-btn-\'+word.combo : \'\'}}\" style=\"border-color:transparent;\">{{word.sentence_display ? word.sentence_display : word.value}}</button> <span popover=\"Undo: Last Step\" popover-placement=\"left\" popover-trigger=\"mouseenter\" style=\"margin-left: 15px;\" class=\"btn btn-large btn-warning\" ng-click=\"undoLastChange();\" ng-show=\"showClear()\"><i class=\"fa fa-undo fa-lg\"></i></span> <span popover=\"Undo: Clear All\" popover-placement=\"left\" popover-trigger=\"mouseenter\" class=\"btn btn-large btn-danger\" ng-click=\"clearSentence();\" ng-show=\"showClear()\"><i class=\"fa fa-trash-o fa-lg\"></i></span></div></full-row-display-set-container></div>");
$templateCache.put("app/views/templates/input/sentenceInterfaceOptions.html","<div><full-row-display-set-container><div ng-controller=\"sentenceInterfaceOptionsController\" ng-init=\"showAdditionalInput=true;\"><div ng-show=\"additionalInputs\"><div ng-repeat=\"input in additionalInputs\" style=\"padding-top:10px; padding-right:10px;\" class=\"btn-group\"><button type=\"button\" class=\"btn btn-large\" ng-click=\"editMode(input)\">Add: <b>{{input.label}}</b></button> <button popover=\"Help with {{input.label}}\" popover-placement=\"left\" popover-trigger=\"mouseenter\" type=\"button\" class=\"btn btn-large btn-info\" ng-click=\"openHelp(input.machine_name)\"><i class=\"fa fa-question-circle fa-lg\"></i></button></div></div><div><div ng-repeat=\"optionInput in optionInputs\" style=\"padding-top:10px; padding-right:10px;\" class=\"btn-group\" dropdown=\"\"><button id=\"btn-{{option.machine_name}}\" type=\"button\" class=\"btn btn-large\" dropdown-toggle=\"\">{{optionInput.label}}: <b>{{optionInput.display_value}}</b></button> <button popover=\"Help with {{optionInput.label}}\" popover-placement=\"left\" popover-trigger=\"mouseenter\" type=\"button\" class=\"btn btn-large btn-info\" ng-click=\"openHelp(optionInput.machine_name)\"><i class=\"fa fa-question-circle fa-lg\"></i></button><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"btn-{{optionInput.machine_name}}\"><li ng-repeat=\"option in optionInput.options\" role=\"menuitem\" ng-click=\"selectionPush(optionInput, option.value)\"><a href=\"#\">{{option.label}}</a></li></ul></div></div></div></full-row-display-set-container></div>");
$templateCache.put("app/views/templates/input/sentenceTypeChooser.html","<div><full-row-display-set-container><div ng-controller=\"sentenceTypeController\"><div style=\"padding-top:10px; padding-right:10px;\" class=\"btn-group\" dropdown=\"\"><button id=\"btn-sentence-type-chooser\" type=\"button\" class=\"btn btn-large\" dropdown-toggle=\"\">Sentence Type: <b>{{chosenType.label}}</b></button> <button popover=\"Help with {{chosenType.label}}\" popover-placement=\"left\" popover-trigger=\"mouseenter\" type=\"button\" class=\"btn btn-large btn-info\" ng-click=\"openHelp(chosenType.machine_name)\"><i class=\"fa fa-question-circle fa-lg\"></i></button><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"btn-sentence-type-chooser\"><li ng-repeat=\"option in sentenceTypes\" role=\"menuitem\" ng-click=\"setSentenceType(option.machine_name)\"><a href=\"#\"><b>{{option.label}}</b>: {{option.shortDescription}}</a></li></ul></div><br><div style=\"padding-top:10px; padding-right:10px;\" class=\"btn-group\" dropdown=\"\"><div bind-compiled-html=\"chosenType.description\"></div></div><br></div></full-row-display-set-container></div>");
$templateCache.put("app/views/templates/input/typeAheadInput.html","<div><label for=\"{{vm.input_type}}_input\" class=\"control-label force_success_black\">{{vm.data_label}} <i ng-show=\"vm.loadingWords\" class=\"no-animate text-success fa fa-refresh fa-spin fa-lg\"></i></label><div class=\"input-group\"><input id=\"{{vm.input_type}}\" type=\"text\" auto-complete-buster=\"\" ng-model=\"vm.selected\" placeholder=\"Start typing...\" typeahead=\"obj as obj.label for obj in vm.getWords(vm.sanitize($viewValue))\" typeahead-loading=\"vm.loadingWords\" typeahead-on-select=\"vm.element_changed(vm.selected);vm.show_clear=true;\" ng-click=\"vm.show_cancel=true;vm.selected=typed_value;\" ng-blur=\"vm.show_cancel=false;vm.restore()\" ng-disabled=\"vm.disabled\" ng-change=\"vm.track_typing(vm.selected)\" class=\"form-control\"> <span popover=\"Cancel Word change\" popover-placement=\"left\" popover-trigger=\"mouseenter\" class=\"input-group-addon btn btn-large btn-success\" ng-init=\"vm.show_cancel=false\" ng-show=\"vm.show_cancel\" ng-click=\"vm.show_cancel=false;vm.restore()\"><i class=\"fa fa-undo fa-lg\"></i></span> <span popover=\"Clear Word\" popover-placement=\"left\" popover-trigger=\"mouseenter\" class=\"input-group-addon btn btn-large btn-danger\" ng-click=\"vm.clear();vm.show_clear=false;\" ng-show=\"vm.show_clear\"><i class=\"fa fa-trash-o fa-lg\"></i></span> <span popover=\"Help with {{data.label}}\" popover-placement=\"left\" popover-trigger=\"mouseenter\" class=\"input-group-addon btn btn-large btn-info\" ng-click=\"vm.openHelp(data_id)\"><i class=\"fa fa-question-circle fa-lg\"></i></span></div></div>");
$templateCache.put("app/views/templates/input/verbInputContainer.html","<div><input-set-container><type-ahead-input type=\"{{\'verb\'}}\" init=\"vm.childHandles.initVerb\" push-change=\"vm.selectedVerb\" get-words=\"vm.getVerbs\"></type-ahead-input></input-set-container></div>");
$templateCache.put("app/views/templates/warning/pronoun_reset_direct_object_noun_warning.html","<div style=\"text-align: center;\"><h4 class=\"bg-warning\">Pronoun Rule Violation:</h4><p>Direct- and Indirect Object Noun <b>cannot</b> both be inserted object concord pronouns.</p><br><p><b>Direct Object Noun</b> has been set to not use pronouns.</p></div>");
$templateCache.put("app/views/templates/warning/pronoun_reset_indirect_object_noun_warning.html","<div style=\"text-align: center;\"><h4 class=\"bg-warning\">Pronoun Rule Violation:</h4><p>Direct- and Indirect Object Noun <b>cannot</b> both be inserted object concord pronouns.</p><br><p><b>Indirect Object Noun</b> has been set to not use pronouns.</p></div>");}]);